import { useState } from 'react';
import {
  CustomDialog,
  Button,
  AutoCompleteController,
  DatePickerController,
} from '../../components';
import { downLoadLink } from '../../utils/functions/common';
import { useAppDispatch } from '../../storeHook';
import { showAlert } from '../../services/alert';
import * as yup from 'yup';
import { useFormWithSchema } from '../../utils/functions/yupFormTypescript';
import { useGetAllPlantsQuery } from '../../services/common';
import { TAutoCompleteOptions } from '../../utils/types';
import dayjs from 'dayjs';
import { useLazyRetailersExportQuery } from '../../services/retailers';

const STATUS_LIST: TAutoCompleteOptions[] = [
  {
    value: 'INCOMPLETE',
    label: 'Incomplete',
  },
  {
    value: 'PENDING',
    label: 'Pending',
  },
  {
    value: 'APPROVE',
    label: 'Approved',
  },
  {
    value: 'REJECT',
    label: 'Rejected',
  },
  {
    value: 'KYC_APPROVE',
    label: 'Verified',
  },
];

const currDate = dayjs();
const formSchema = yup.object({
  plant: yup.string(),
  status: yup.string(),
  startDate: yup
    .date()
    .required('Start Date is required')
    .default(dayjs(currDate).subtract(1, 'days').toDate()),
  endDate: yup
    .date()
    .required('End Date is required')
    .default(dayjs(currDate).toDate()),
});
type TFormData = yup.InferType<typeof formSchema>;

export const Export: React.FC = () => {
  const { data: plantList } = useGetAllPlantsQuery();
  const formattedPlantList = plantList?.map((ele) => ({
    value: ele.plantCode,
    label: `${ele.plantName} [${ele.plantCode}]`,
  }));

  const {
    formState: { errors },
    handleSubmit,
    control,
    watch,
  } = useFormWithSchema(formSchema, {
    mode: 'onTouched',
  });

  const dispatch = useAppDispatch();
  const [exportAction] = useLazyRetailersExportQuery();
  const [open, setOpen] = useState(false);

  const onExportClick = ({
    startDate,
    endDate,
    status,
    plant,
  }: TFormData) => {
    exportAction({
      fromDate: dayjs(startDate).format('DD-MM-YYYY'),
      toDate: dayjs(endDate).format('DD-MM-YYYY'),
      status,
      werks: plant,
    })
      .unwrap()
      .then((res) => {
        downLoadLink(res.url);
        dispatch(
          showAlert({
            content: res.url
              ? 'Exported Successfully'
              : 'No data found with applied conditions',
            severity: res.url ? 'success' : 'error',
          })
        );
      })
      .catch((err) => {
        console.log('error', err);
        // this.utility.handleError(err);
      });
  };

  return (
    <>
      <Button
        onClick={() => setOpen(!open)}
        variant="button--secondary">
        Export
      </Button>
      <CustomDialog
        dialogTitle={'Retailers Export'}
        open={open}
        setOpen={setOpen}
        onSubmit={handleSubmit((data) =>
          onExportClick(data)
        )}
        actionText={{ submit: 'Export', cancel: 'Cancel' }}
        maxWidth="md">
        <form
          onSubmit={handleSubmit((data) =>
            onExportClick(data)
          )}
          className="grid grid-cols-2 gap-8 pb-36 mb-10 ">
          <DatePickerController
            label="Retailer created start date"
            control={control}
            name="startDate"
            error={errors.startDate?.message}
            selectsStart
            startDate={watch('startDate')}
            endDate={watch('endDate')}
          />
          <DatePickerController
            label="Retailer created end date"
            control={control}
            name="endDate"
            error={errors.endDate?.message}
            selectsEnd
            startDate={watch('startDate')}
            endDate={watch('endDate')}
          />
          <AutoCompleteController
            label="Status"
            name="status"
            control={control}
            options={STATUS_LIST}
            error={errors.status?.message}
            isDefaultValueNull
          />
          <AutoCompleteController
            label="Plant"
            name="plant"
            control={control}
            options={formattedPlantList}
            error={errors.plant?.message}
            isDefaultValueNull
          />
        </form>
      </CustomDialog>
    </>
  );
};
